import api from './api';
const base='/contacts/imports';
export const contactImportsAPI={
 capabilities:()=>api.get(`${base}/capabilities`),
 list:before=>api.get(base,{params:before?{before}:undefined}),
 get:id=>api.get(`${base}/${id}`),
 action:(id,action,data={})=>api.post(`${base}/${id}/${action}`,data),
 upload:async file=>{
  const {data}=await api.post(base,{filename:file.name,size:file.size});
  const response=await fetch(data.signedUrl,{method:'PUT',headers:{'Content-Type':data.contentType},body:file});
  if(!response.ok)throw new Error('Upload failed. Choose the file and try again.');
  await api.post(`${base}/${data.id}/prepare`);
  return data.id;
 },
 report:id=>api.get(`${base}/${id}/report`,{responseType:'blob'}),
};
